import axios from 'axios'
import { useGlobalStore } from '@/stores/global'

export const useRemember = () => {
	const globalStore = useGlobalStore()

	const remember = async () => {
		if (globalStore.isLoggedIn) {
			try {
				const response = await axios.get('/auth/user')

				// TODO: Use the response user data, and provide route based checking
				// globalStore.user = response.data...
			} catch (error) {
				if (
					axios.isAxiosError(error) &&
					error.response?.status === 401
				) {
					globalStore.setBearer(null)
					globalStore.user = null
				}
			}
		}
	}

	return {
		remember
	}
}
